export default function Marquee() {
  const phrase = "FUEL THE ENERGY INSTANTLY \u2022 FRESH. FUNCTIONAL. FAST. \u2022 NUTRITION ON TAP \u2022 ";
  return (
    <section data-testid="marquee" className="relative bg-[#17320B] py-8 md:py-12 overflow-hidden">
      <div className="marquee-track">
        {[0, 1].map((i) => (
          <span key={i} className="font-display uppercase text-[9vw] leading-none px-4 text-[#D9F4CD]">
            {phrase}
          </span>
        ))}
      </div>
    </section>
  );
}
